import { render, staticRenderFns } from "./BatchListDialog.vue?vue&type=template&id=57377932&scoped=true&"
import script from "./BatchListDialog.vue?vue&type=script&lang=js&"
export * from "./BatchListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57377932",
  null
  
)

export default component.exports